import { TDeviceType } from '@cian/ui-kit';

import { getPlatformByDeviceType } from './getPlatformByDeviceType';
import { EHostType } from '../types/hostType';

interface IGetModifiedTelemetryKeyProps {
  eventKey: string;
  deviceType: TDeviceType;
  hostType: EHostType;
}

/**
 * @description
 * Добавляет к событию телеметрии префикс платформы и источника (page/frame).
 * Пример: desktop.frame.{eventKey}
 */
export function getTelemetryKeyByPlatformAndHostType({
  eventKey,
  deviceType,
  hostType,
}: IGetModifiedTelemetryKeyProps): string {
  const platform = getPlatformByDeviceType(deviceType);

  return `${platform}.${hostType}.${eventKey}`;
}
